import { Box } from "@mui/material";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";

export default function IconContainer({ IconSVG, size = "S" }) {
  const colors = useColors();

  const sizeMap = {
    XS: {
      containerSize: "18px",
      iconSize: "13.5px",
      border: "0.5px",
      borderRadius: "4px",
    },
    S: {
      containerSize: "24px",
      iconSize: "16.5px",
      border: "1px",
      borderRadius: "4px",
    },
    M: {
      containerSize: "32px",
      iconSize: "24px",
      border: "1px",
      borderRadius: "6px",
    },
    L: {
      containerSize: "48px",
      iconSize: "36px",
      border: "1px",
      borderRadius: "8px",
    },
  };

  return (
    <Box
      width={sizeMap[size].containerSize}
      height={sizeMap[size].containerSize}
      border={`${sizeMap[size].border} solid ${colors.grey_24percent}`}
      borderRadius={sizeMap[size].borderRadius}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <SvgToIcon IconLogo={IconSVG} width={sizeMap[size].iconSize} />
    </Box>
  );
}
